import { useState } from "react";
import HeroSection from "@/components/HeroSection";
import MissionSection from "@/components/MissionSection";
import ProductsSection from "@/components/ProductsSection";
import EmailCaptureSection from "@/components/EmailCaptureSection";
import FooterSection from "@/components/FooterSection";
import EmailModal from "@/components/EmailModal";

export default function LandingPage() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div data-testid="landing-page" style={{ backgroundColor: "var(--blush)" }}>
      <HeroSection onCtaClick={() => setModalOpen(true)} />
      <MissionSection />
      <ProductsSection />
      <EmailCaptureSection />
      <FooterSection />
      <EmailModal open={modalOpen} onOpenChange={setModalOpen} />
    </div>
  );
}
